import { initGlobalOptions } from "./config";
import './roundedCornersExtension'
export default {
  mounted() {
    initGlobalOptions();
  }
}
